import { IParagraphStyle } from '@src/slide/domain/ui-model/element-modeles/property/text/interface/editor-styles.interface';
import DataTransform from '@src/slide/domain/ui-model/element-modeles/property/text/editor-data-model/data-transform';

export function transformParagraphForCharacter(documentParagraph) {
    const paraStyle: IParagraphStyle = DataTransform.getOriginProps(documentParagraph);
    const textRuns = documentParagraph?.children.map((run) => {
        const styles = DataTransform.getOriginProps(run, 'raw-');
        return {
            text: run.text,
            styles,
        };
    });
    return {
        paragraphProps: paraStyle,
        textRuns,
    };
}
